import React from 'react';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import { updateHaveUnsavedChanges, updateIntroCardPosition, updatePageSettings } from '../../actions/builder-action';
import useConfigPathFromStore from '../../hooks/useConfigPathFromStore';
import { Checkbox } from '@quintype/em/components/checkbox';
import styles from './header-dropdown.module.css';

const LayoutSettings = () => {
  const configPath = useConfigPathFromStore();
  const { enableIntroCard = false } =
    useSelector(state => get(state, ['builder', 'config', ...configPath, 'pageSetting'])) || {};

  const dispatch = useDispatch();

  const handleVisibilityChange = (value: boolean) => {
    if (value) {
      dispatch(updateIntroCardPosition());
    }
    dispatch(updatePageSettings({ enableIntroCard: value }));
    dispatch(updateHaveUnsavedChanges(true));
  };

  return (
    <div className={styles.checkboxWrapper}>
      <Checkbox
        label="Section Page Introduction Card"
        id="enableSectionIntroductionCard"
        checked={enableIntroCard}
        onChange={(value: boolean) => handleVisibilityChange(value)}
      />
    </div>
  );
};

export default LayoutSettings;
